import type { Snapshot } from '@/entities/snapshot';
import request from '@/shared/api/request';

/**
 * Tranfser Snapshot to specified region.
 *
 * @param id { number } The ID of the Snapshot.
 * @param region { string } The name of the region.
 * @param action { string } The name of action.
 */
export const transferSnapshot = (data: {
  id: number;
  region: string;
  action: string;
}): Promise<{ snapshot: Snapshot }> =>
  request({
    url: `/snapshots/${data.id}`,
    method: 'POST',
    data: { region: data.region, action: data.action },
  });
